import { NgModule, provideAppInitializer } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { InvitationComponent } from './public/invitation/invitation.component';
import { InvitationResolverComponent } from './public/invitation-resolver/invitation-resolver.component';

import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NotificationComponent } from './shared/components/notification/notification.component';
// import { NgChartsModule } from 'ng2-charts';
import { ApiInterceptor } from './shared/interceptor/api/api.interceptor';
import { DataService } from './shared/core.index';
import { AuthService } from './auth/auth.service';
// import { CommonService } from './core/core.index';
// import { PublicConfig } from './core/models/common.model';
// import { AuthService } from './auth/auth.service';
// import { PublicComponent } from './public/public.component';

// import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';


export function loadConfig() {
  return () => {
    const url = new URL(window.location.href);
    const code: string = url.searchParams.get('code') || '';
    const iframe = url.searchParams.get('iframe') || 'false';
    localStorage.setItem('iframe', iframe);
    if (url.searchParams.has('self')) {
      const self = url.searchParams.get('self') || '';
      const currentSelf = localStorage.getItem('self');
      if (self !== '') {
        localStorage.setItem('self', self);
      }
    }
    return Promise.resolve(true);
  };
}

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    NotificationComponent,
    InvitationComponent,
    InvitationResolverComponent
    // PublicComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    HttpClientModule
  ],
  exports: [],
  bootstrap: [AppComponent],

  providers: [
    provideAppInitializer(() => {
        const initializerFn = (loadConfig)();
        return initializerFn();
      }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule { }
